const BARCODE_PREFIX_SETTINGS_KEY = 'barcodePrefixMappings';
const BARCODE_PREFIX_MAX_LENGTH = 1;
const BARCODE_MODE_OPTIONS = ['weight', 'amount', 'price'];
const RESERVED_BARCODE_PREFIXES = ['9'];

const DEFAULT_BARCODE_PREFIX_MAPPINGS = [{ prefix: '2', mode: 'weight' }];

const digitsOnly = (value) => String(value || '').replace(/\D/g, '');

const sanitizeBarcodePrefixInput = (value) =>
  digitsOnly(value).slice(0, BARCODE_PREFIX_MAX_LENGTH);

const isReservedBarcodePrefix = (value) =>
  RESERVED_BARCODE_PREFIXES.includes(sanitizeBarcodePrefixInput(value));

const normalizeMappings = (mappings) => {
  if (!Array.isArray(mappings)) return [];
  const seen = new Set();
  const normalized = [];

  mappings.forEach((item) => {
    const prefix = sanitizeBarcodePrefixInput(item?.prefix);
    const mode = BARCODE_MODE_OPTIONS.includes(item?.mode) ? item.mode : 'weight';
    if (!prefix || seen.has(prefix) || isReservedBarcodePrefix(prefix)) return;
    seen.add(prefix);
    normalized.push({ prefix, mode });
  });

  return normalized;
};

const getBarcodePrefixMappings = () => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return DEFAULT_BARCODE_PREFIX_MAPPINGS;
  }
  try {
    const raw = window.localStorage.getItem(BARCODE_PREFIX_SETTINGS_KEY);
    if (!raw) return DEFAULT_BARCODE_PREFIX_MAPPINGS;
    const parsed = JSON.parse(raw);
    const normalized = normalizeMappings(parsed);
    return normalized.length ? normalized : DEFAULT_BARCODE_PREFIX_MAPPINGS;
  } catch (error) {
    return DEFAULT_BARCODE_PREFIX_MAPPINGS;
  }
};

const saveBarcodePrefixMappings = (mappings) => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return normalizeMappings(mappings);
  }
  const normalized = normalizeMappings(mappings);
  window.localStorage.setItem(BARCODE_PREFIX_SETTINGS_KEY, JSON.stringify(normalized));
  return normalized;
};

export {
  BARCODE_PREFIX_MAX_LENGTH,
  BARCODE_MODE_OPTIONS,
  RESERVED_BARCODE_PREFIXES,
  DEFAULT_BARCODE_PREFIX_MAPPINGS,
  getBarcodePrefixMappings,
  saveBarcodePrefixMappings,
  sanitizeBarcodePrefixInput,
  isReservedBarcodePrefix,
};
